import React from 'react'
import { Formik } from 'formik'
import * as Yup from 'yup'
import { useDispatch } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { useEventSlug } from 'hooks'
import routes from 'routes'
import { _, validation, withCapture } from 'utils'
import { DateTime } from 'utils/datetime'
import FormTabs from '../forms/FormTabs'
import GeneralSetting from './tabs/GeneralSetting'
import SpeakerInfo from './tabs/SpeakerInfo'
import VirtualEvent from './tabs/VirtualEvent'
import { createShow } from './graphql/mutation'
import { showNotification } from '../notifications'
import { showErrorNotification } from '../notifications/notificationsSlice'
import App from './tabs/App'

export const ShowValidation = Yup.object().shape({
    name: Yup.string().required().min(3),
    externalId: validation.externalId.nullable(),
    startDate: Yup.date().required(),
    endDate: validation.endDateProgram,
    color: validation.color.required(),
    moderatorEmail: Yup.string().email(),
    streamUrl: validation.url.nullable(),
    embeddedUrl: validation.url.nullable(),
    playbackUrl: validation.url.nullable(),
})

const CreateShow = () => {
    const eventSlug = useEventSlug()
    const history = useHistory()
    const dispatch = useDispatch()
    const location = useLocation<{ id: number, startDate: DateTime, endDate: DateTime }>()
    const { id: containerId, startDate, endDate } = location?.state || {}

    return (
        <Formik
            initialValues={{
                name: '',
                startDate: startDate ? new Date(startDate) : new Date(),
                endDate: endDate ? new Date(endDate) : new Date(),
                color: '#ececec',
                moderatorEmail: '',
                streamUrl: '',
                embeddedUrl: '',
                performerIds: [],
                attachment: '',
                containerId,
                releaseDate: new Date(),
            }}
            onSubmit={withCapture(async (values) => {
                const response = await createShow({ ...values, event: eventSlug })
                if (response.data) {
                    // After submitting successfully, redirect to edit page
                    history.push(routes.updateShow.getPath({ eventSlug, id: response.data?.createShow?.id }))
                    dispatch(showNotification({
                        type: 'success',
                        body: _('form.notification.update_success'),
                    }))
                } else {
                    dispatch(showErrorNotification(response.errors))
                }
            })}
            validationSchema={ShowValidation}
        >
            <FormTabs
                tabs={[
                    { id: 'general', name: _('show.tabs.general_setting'), Component: GeneralSetting },
                    {
                        id: 'speaker',
                        name: _('show.tabs.speaker_info'),
                        Component: () => <SpeakerInfo name="performerIds" />
                    },
                    { id: 'virtualspace', name: _('show.tabs.virtual_event'), Component: VirtualEvent },
                    { id: 'app', name: _('show.tabs.app'), Component: App }
                ]}
            />
        </Formik>
    )
}

export default CreateShow
